export const serializeQuery = (payload) => {
    return Object.keys(payload)
        .map(
            (key) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(
                    payload[key],
                )}`,
        )
        .join('&');
};

// creates a query string from query object
export const createQueryString = (queryObject = {}) => {
    let queryString = Object.keys(queryObject)
        .filter(
            (key) =>
                queryObject[key] &&
                !(Array.isArray(queryObject[key]) && !queryObject[key].length),
        )
        .map((key) => {
            return Array.isArray(queryObject[key])
                ? queryObject[key]
                      .map(
                          (item) =>
                              `${encodeURIComponent(key)}=${encodeURIComponent(
                                  item,
                              )}`,
                      )
                      .join('&')
                : `${encodeURIComponent(key)}=${encodeURIComponent(
                      queryObject[key],
                  )}`;
        })
        .join('&');
    return queryString ? `?${queryString}` : '';
};

// turns query string into an object
export const queryStringToObject = (queryString = '', options = {}) => {
    if (!queryString || typeof queryString !== 'string') return {};

    return decodeURIComponent(queryString.replace(/^\?/, ''))
        .split('&')
        .reduce((queryObject, itemString) => {
            let [itemKey, itemValue] = itemString.split('=');

            if (!itemKey) return queryObject; // Пропуск некорректных данных

            if (options.hasOwnProperty(itemKey)) {
                if (Array.isArray(options[itemKey])) {
                    queryObject[itemKey] = queryObject[itemKey] || [];
                    queryObject[itemKey].push(itemValue);
                } else {
                    queryObject[itemKey] =
                        typeof options[itemKey] === 'number'
                            ? Number(itemValue)
                            : itemValue;
                }
            }

            return queryObject;
        }, {});
};
